import React from 'react';
import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { PAGE_SIZE_OPTIONS } from '../../hooks/usePagination';
import { AppSelect } from './AppSelect';
import { OutlineButton } from './Buttons';

export function TablePagination({
  page,
  pageSize,
  totalCount,
  totalPages,
  onPageChange,
  onPageSizeChange,
  px = { base: 5, xl: 6 },
  suffix,
}) {
  const start = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalCount);

  return (
    <Flex
      px={px}
      py={3}
      borderTopWidth="1px"
      borderColor="border.subtle"
      justify="space-between"
      align="center"
      wrap="wrap"
      gap={3}
    >
      <Text fontSize="13px" color="text.secondary">
        Showing {start}–{end} of {totalCount}
        {suffix ? ` ${suffix}` : ''}
      </Text>
      <HStack spacing={4} flexWrap="wrap">
        <Flex align="center" gap={2}>
          <Text fontSize="13px" color="text.secondary" whiteSpace="nowrap">
            Rows per page
          </Text>
          <Box minW="100px" w="100px">
            <AppSelect
              value={String(pageSize)}
              onChange={(v) => onPageSizeChange(Number(v) || 10)}
              options={PAGE_SIZE_OPTIONS}
              h="36px"
            />
          </Box>
        </Flex>
        <HStack>
          <OutlineButton
            size="sm"
            leftIcon={<MdChevronLeft />}
            isDisabled={page <= 1}
            onClick={() => onPageChange(Math.max(1, page - 1))}
          >
            Prev
          </OutlineButton>
          <Text fontSize="13px" fontWeight="600" minW="80px" textAlign="center">
            Page {page} / {totalPages}
          </Text>
          <OutlineButton
            size="sm"
            rightIcon={<MdChevronRight />}
            isDisabled={page >= totalPages}
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          >
            Next
          </OutlineButton>
        </HStack>
      </HStack>
    </Flex>
  );
}
